// buildInfo.js — marqueur de version de BUILD.
// Objectif : permettre de VÉRIFIER d'un coup d'œil (pied de page) qu'une build FRAÎCHE
// est bien en ligne. Symptôme classique : « le correctif ne s'affiche pas » alors que
// le code est déjà corrigé et poussé → c'est le frontend déployé (Vercel) qui est périmé.
// → Bumper cette valeur à chaque lot de correctifs frontend ; comparer avec le pied de page.
export const BUILD_VERSION = '2026-08-30.49';
